import React from 'react';
import type ProjectSettingsProformaProjectFormsType from '@atlassian/jira-spa-apps-project-settings-proforma-project-forms/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsProformaProjectForms = lazyForPaint<
	typeof ProjectSettingsProformaProjectFormsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-proforma-project-forms", jiraSpaEntry: "async-project-settings-proforma-project-forms" */ '@atlassian/jira-spa-apps-project-settings-proforma-project-forms'
		),
);

const AsyncProjectSettingsProformaProjectForms = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsProformaProjectForms}
		pageId="project-settings-proforma-project-forms"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsProformaProjectForms;
